import React from 'react';
import { Typography } from 'antd';
import { getLegalDocumentFallbackContent } from '../../constants/legalDocumentFullContent';

type LegalDocumentBodyProps = {
  slug: string;
  content?: string | null;
};

const LegalDocumentBody: React.FC<LegalDocumentBodyProps> = ({ slug, content }) => {
  const bodyText = (content && content.trim()) || getLegalDocumentFallbackContent(slug);

  if (!bodyText) {
    return (
      <Typography.Paragraph type="secondary">暂无协议正文，请联系平台客服获取最新版本。</Typography.Paragraph>
    );
  }

  return (
    <div
      className="legal-document-body"
      style={{
        whiteSpace: 'pre-wrap',
        lineHeight: 1.85,
        fontSize: 15,
        color: 'rgba(0, 0, 0, 0.88)',
      }}
    >
      {bodyText}
    </div>
  );
};

export default LegalDocumentBody;
